import React, { ReactElement } from "react";
import PolicyCardArt from "./PolicyCardArt";
import { PolicyType } from "../types";
import "./Prompts.css";

type PolicyCardsProps = {
  policies: PolicyType[];
  /** Index of the chosen card, when the cards can be chosen. */
  selection?: number;
  /** Called with the index when a card is chosen. Leave out to show the cards without choosing. */
  onSelect?: (index: number) => void;
  /** Tag shown on the chosen card ("Discard", "Enact"). */
  selectedTag?: string;
  selectedTagKind?: "discard" | "enact";
  /** Tag for each card when the cards are only shown (peek): "Top card", "2nd", ... */
  tags?: string[];
  disabled?: boolean;
};

/** A row of policy cards, drawn with the game's card art, that can be chosen with mouse, touch or keyboard. */
export default function PolicyCards(props: PolicyCardsProps): ReactElement {
  const choosable = props.onSelect !== undefined;
  return (
    <div className="pp-cards" role={choosable ? "radiogroup" : undefined}>
      {props.policies.map((policy, index) => {
        const selected = props.selection === index;
        const dim = choosable && props.selection !== undefined && !selected;
        const tag = selected ? props.selectedTag : props.tags?.[index];
        let tagClass = "pp-card-tag";
        if (selected && props.selectedTagKind) {
          tagClass += " pp-card-tag-" + props.selectedTagKind;
        } else if (!choosable) {
          tagClass += index === 0 ? " pp-card-tag-first" : " pp-card-tag-peek";
        }
        return (
          <button
            key={index}
            type="button"
            className={
              "pp-card" +
              (selected ? " pp-card-selected" : "") +
              (dim ? " pp-card-dim" : "") +
              (choosable ? "" : " pp-card-static")
            }
            role={choosable ? "radio" : undefined}
            aria-checked={choosable ? selected : undefined}
            tabIndex={choosable ? 0 : -1}
            disabled={props.disabled}
            onClick={() => props.onSelect && props.onSelect(index)}
          >
            <PolicyCardArt policy={policy} />
            {tag && <span className={tagClass}>{tag}</span>}
          </button>
        );
      })}
    </div>
  );
}
